'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action = require('./action');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    stack: []
  };
  var action = arguments[1];

  switch (action.type) {
    case _action.ActionType.SHOW:
      return _extends({}, state, {
        stack: [].concat(_toConsumableArray(state.stack), [{
          id: new Date().valueOf(),
          component: action.component,
          props: action.props,
          show: true,
          delayBeforeRemoveMsec: action.delayBeforeRemoveMsec
        }])
      });

    case _action.ActionType.HIDE:
      var targetModal = state.stack.find(function (modal) {
        return modal.id === action.id;
      });

      if (!targetModal) {
        return state;
      }

      return _extends({}, state, {
        stack: [].concat(_toConsumableArray(state.stack.filter(function (modal) {
          return state.stack.indexOf(modal) < state.stack.indexOf(targetModal);
        })), [_extends({}, targetModal, {
          show: false
        })], _toConsumableArray(state.stack.filter(function (modal) {
          return state.stack.indexOf(modal) > state.stack.indexOf(targetModal);
        })))
      });

    case _action.ActionType.REMOVE:
      return _extends({}, state, {
        stack: state.stack.filter(function (modal) {
          return modal.id !== action.id;
        })
      });

    default:
      return state;
  }
};

exports.default = reducer;